import React, { useState, useEffect } from "react";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import useGetEmailWorkFLow from "./hooks/useEmailWorkFlow";
import useDeleteEmailWorkflow from "./hooks/useDeleteEmailWorkflow";
import { useRecoilState, useRecoilValue } from "recoil";
import { toast } from "../../../../components/toastNotification";
import { useQueryClient } from "react-query";
import {
  addStateEmailWorkFlow,
  selectedRowsStateEmailWorkFlow,
} from "./atoms/atoms";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import TableFilters from "./TableFilters";
import AddButton from "../../../../components/AddButton";
import AddEmailWorkFlowForm from "./AddEmailWorkFlowForm";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import useOperations from "./hooks/useOperations";
import useFilteredOperation from "./hooks/useFilteredOperation";
import useupdateEmailWorkflow from "./hooks/useUpdateEmailWorkFlow";
import MultiSelectInput from "../../../../components/MultiSelectInput";
import { useHistory, useLocation } from "react-router-dom";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
const EmailWorkFlowTable = () => {
  //user permissions
  const queryClient = useQueryClient();
  const addPermission = PERMISSIONS.permission_utilities_emailworkflow_add;
  const editPermission = PERMISSIONS.permission_utilities_emailworkflow_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_emailworkflow_delete;
  const userPermissions = useRecoilValue(permissionsSelector);
  //atoms
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateEmailWorkFlow
  );
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateEmailWorkFlow
  );
  //Local State
  const [rowsCount, setRowsCount] = useState(0);
  const [workflowFilteredData, setWorkflowFilteredData] = useState([]);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [defaultOperationValue, setDefaultOperationValue] = useState();
  const [dropDownModules, setdropDownModules] = useState();
  const [editRowId, setEditRowId] = useState(null);
  const [edit, setEdit] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [disabledButton, setDisabledButton] = useState(false);
  const [actionEditState, setActionEditState] = useState(false);
  const [hasEmailWorkFlow, setHasEmailWorkFlow] = useState(true);
  const [operationsIsChange, setOperationsIsChange] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const userAccount = useRecoilValue(accountAtom);

  //hooks
  const {
    mutate: deleteEmailWorkflow,
    isSuccess: isSuccessDelete,
    reset: isResest,
  } = useDeleteEmailWorkflow();
  const { data: emailWorkFlowData, isFetching } = useGetEmailWorkFLow();
  const { mutateAsync: updateEmailWorkflow } = useupdateEmailWorkflow();
  const defaulValues = {
    previousEvents: "",
    events: "",
    eventId: 0,
    operationIds: [],
    isActive: 0,
    createdBy: "",
    createdDate: "",
    modifiedBy: "",
    modifiedDate: "",
  };
  const [newEmailWorkFlow] = useState([defaulValues]);
  const { data: operationsTypeQuery } = useOperations();
  const { data: filteredOperationsQuery, refetch } = useFilteredOperation();
  if (isSuccessDelete) {
    queryClient.invalidateQueries("GetEmailWorkFlow");
    refetch();
    setSelectedRows([]);
    setDisabledButton(false);
    toast.fire(
      "Success",
      "Email Workflow were deactivated successfully",
      "success"
    );
    isResest();
  }
  const [workflowId, setWorkflowId] = useState("");
  useEffect(() => {
    if (workflowId !== "") {
      if (workflowId?.includes(".")) {
        let ids = workflowId.split(".");
        const idsArr = ids.map((id) => id);
        const filteredData = emailWorkFlowData?.filter((x) =>
          idsArr.includes(String(x.eventId))
        );
        setWorkflowFilteredData(filteredData);
      } else {
        const filteredData = emailWorkFlowData?.filter(
          (x) => x.eventId === Number(workflowId)
        );
        setWorkflowFilteredData(filteredData);
      }
    }
  }, [emailWorkFlowData, workflowId]);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }
  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setWorkflowFilteredData(result);
          setWorkflowId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);
  //Filters
  const filteredItems = emailWorkFlowData
    ? emailWorkFlowData?.filter(
        (item) =>
          item.events &&
          item.events.toLowerCase().includes(filterText?.trim().toLowerCase())
      )
    : [];
  useEffect(() => {
    setEditRowId([]);
    handleSaveButton();
  }, []);
  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    if (actionEditState === true) {
      setSelectedRows();
    }
  };

  //columns
  const matColumns = [
    {
      title: "Events",
      field: "events",
      align: "left",
      render: (rowData) => {
        return <>{rowData.events}</>;
      },
    },
    {
      title: "Operations Group",
      // align: "center",
      field: "operationNames",
      render: (rowData) => {
        return rowData.events === editRowId ? (
          <div className="w-full text-right mr-24">
            <MultiSelectInput
              menuPortalTarget={document.body}
              defaultValue={defaultOperationValue}
              styles={customStyles}
              isMulti
              closeMenuOnSelect={false}
              options={dropDownModules}
              className="basic-multi-select"
              classNamePrefix="select"
              handleMultiSelect={handleMultiSelectModule}
            />
          </div>
        ) : (
          <>{rowData.operationNames}</>
        );
      },
    },
    {
      title: "Created By",
      align: "left",
      field: "createdBy",
      render: (rowData) => {
        return <>{rowData.createdBy}</>;
      },
    },
    {
      title: "Created Date",
      align: "left",
      field: "createdDate",
      render: (rowData) => {
        return (
          <>
            {rowData.createdDate
              ? new Date(rowData.createdDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified By",
      align: "left",
      field: "modifiedBy",
      render: (rowData) => {
        return <>{rowData.modifiedBy}</>;
      },
    },
    {
      title: "Modified Date",
      align: "left",
      field: "modifiedDate",
      render: (rowData) => {
        return (
          <>
            {rowData.modifiedDate
              ? new Date(rowData.modifiedDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Status",
      align: "left",
      field: "status",
      render: (rowData) => {
        return <>{rowData.status}</>;
      },
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.events === editRowId ? (
          <div className="flex justify-center gap-2 ">
            <SaveButton
              className={`flex shadow-md text-xs font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${!hasEmailWorkFlow ? "opacity-50" : "opactiy-100"}`}
              disabled={!hasEmailWorkFlow}
              onClick={() => {
                setOpenModalEdit(true);
              }}
            />
            <CancelButton
              className="flex text-xs shadow-md font-semibold text-white ml-1 gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClick={() => {
                setActionEditState(false);
                setEditRowId([]);
                setDisabledButton(false);
                setOperationsIsChange(false);
                setEdit(false);
              }}
            />
          </div>
        ) : (
          <div className="flex place-content-center mr-4">
            <EditButton
              disabled={disabledButton || selectedRows.length > 0}
              className={
                disabledButton || selectedRows.length > 0
                  ? "opacity-50"
                  : "opacity-100 "
              }
              onClick={() => {
                setDisabledButton(true);
                setActionEditState(true);
                handleEditButton(rowData);
                setEdit(true);
              }}
            />
          </div>
        );
      },
    },
  ];
  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.events);
    setOpenModalDelete(false);
    deleteEmailWorkflow(ids);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Email Workflows" : "Email Workflow"
    }?`}</div>
  );
  // const handleEditFieldsChange = (fieldName, inputValue) => {
  //   setEventFieldIsChange(true);
  //   if (fieldName === "operationsGroup") {
  //     newEmailWorkFlow.map((x) => (x.events = inputValue));
  //   }
  //   handleSaveButton();
  // };
  const handleMultiSelectModule = (selectedOperations) => {
    setOperationsIsChange(true);
    const operationId = [];
    selectedOperations.forEach((m) => {
      operationId.push(m.value);
    });
    newEmailWorkFlow.map((x) => (x.operationIds = operationId));
    handleSaveButton();
  };
  const handleSaveButton = () => {
    newEmailWorkFlow.map((x) =>
      x.operationIds.length !== 0
        ? setHasEmailWorkFlow(true)
        : setHasEmailWorkFlow(false)
    );
  };

  const handleEditButton = (rowData) => {
    setHasEmailWorkFlow(false);
    setEditRowId(rowData.events);
    setEdit(true);
    setdropDownModules(
      operationsTypeQuery.map((m) => {
        return { label: m.operationName, value: m.operationId };
      })
    );
    newEmailWorkFlow.map((x) => (x.previousEvents = rowData.events));
    newEmailWorkFlow.map((x) => (x.events = rowData.events));
    newEmailWorkFlow.map((x) => (x.createdBy = rowData.createdBy));
    newEmailWorkFlow.map((x) => (x.createdDate = rowData.createdDate));
    newEmailWorkFlow.map((x) => (x.modifiedBy = userAccount.userName));
    newEmailWorkFlow.map((x) => (x.modifiedDate = new Date().toISOString()));

    const filteredOperation = filteredOperationsQuery.filter(
      (item) => item.events === rowData.events && item.isActive === true
    );
    const operations = filteredOperation.map((m) => {
      return { label: m.operationNames, value: m.operationId };
    });
    const defaultOperation = [];
    operations.forEach((m) => {
      defaultOperation.push(m.value);
    });
    if (defaultOperation[0] !== 0) {
      newEmailWorkFlow.map((x) => (x.operationIds = defaultOperation));
      setDefaultOperationValue(operations);
    }
  };

  const handleSave = (newEmailWorkFlow) => {
    if (operationsIsChange) {
      updateEmailWorkflow(newEmailWorkFlow, {
        onSuccess: () => {
          queryClient.invalidateQueries(["GetEmailWorkFlow"]);
          queryClient.invalidateQueries(["FilteredOperation"]);
          setEditRowId([]);
          setSelectedRows([]);
          setOpenModalEdit(false);
          setActionEditState(false);
          setDisabledButton(false);
          setEdit(false);
          toast.fire(
            "Success",
            "Email Workflow Updated Successfully",
            "success"
          );
        },
        onError: () => {
          toast.fire("Failed", "Failed to Update Email Workflow", "error");
        },
      });
    } else {
      toast.fire("Saving Failed", "Email Workflow already exists!", "warning");
      setOpenModalEdit(false);
    }
  };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#edebeb",
      minHeight: "28px",
      //   height: "9px",
      boxShadow: state.isFocused ? null : null,
      fontSize: "12px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div className="animate-fade-in-down">
      {actionAddState ? (
        ""
      ) : (
        <div className="font-bold text-primary text-xl uppercase">
          {/* Email Workflow */}
        </div>
      )}
      {!actionAddState && (
        <div className="p-4 w-full">
          <div className="flex justify-between text-xs items-center">
            <div className="">
              <TableFilters
                filterText={setFilterText}
                moduleDetails="Email Workflow"
                textInputName="emailWorkFlow"
                disabledButton={disabledButton || selectedRows.length > 0}
              ></TableFilters>
            </div>
            <div className="">
              {userPermissions.includes(addPermission) ? (
                <AddButton
                  buttonText="New Email Workflow"
                  className={
                    selectedRows.length > 0 || actionEditState || disabledButton
                      ? "opacity-50"
                      : "opacity-100"
                  }
                  onClick={() => setActionAddState(!actionAddState)}
                  disabled={disabledButton || selectedRows.length > 0}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="">
            {userPermissions.includes(deletePermission) ? (
              <div className="text-secondary italic text-xs3 my-2">
                <p className="font-bold italic inline-block mr-1">Note:</p>
                <span>Tick the box to deactivate some data.</span>
              </div>
            ) : (
              <div className="mb-4"></div>
            )}
          </div>
          <div className="overflow-auto box-shadow">
            <MaterialExTable
              columns={matColumns}
              data={
                workflowFilteredData?.length > 0
                  ? workflowFilteredData
                  : filterText === ""
                  ? emailWorkFlowData
                  : filteredItems
              }
              options={{
                toolbar: false,
                showTitle: false,
              }}
              isLoading={isFetching}
              selection={
                !actionEditState && userPermissions.includes(deletePermission)
              }
              setOpenModal={setOpenModalDelete}
              onSelectionChange={handleSelectedRowsChange}
              selectedRows={selectedRows}
              isDeactivate={true}
              selectableRowDisabled={actionEditState}
            />
          </div>
          <ConfirmBoxModal
            ModalTitle="Update Email Workflow"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => setOpenModalEdit(false)}
            onClickFunction={() => {
              handleSave(newEmailWorkFlow);
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate Email Workflow"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={handleBulkDelete}
          />
        </div>
      )}
      {actionAddState && (
        <div className="px-4 py-2">
          <AddEmailWorkFlowForm />
        </div>
      )}
    </div>
  );
};
export default EmailWorkFlowTable;
